import Modal from "react-bootstrap/esm/Modal";
import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/esm/Button";
import {Spinner} from "react-bootstrap";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";

const MassSendCdrAiModal = ({show, setShow, selectedRows, filters, successfulCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loadingMode, setLoadingMode] = useState(null);
    const [consoleLines, setConsoleLines] = useState([]);

    useEffect(() => {
        if (show) {
            setLoadingMode(null);
            setConsoleLines([]);
        }
    }, [show]);

    const isAllSelected = selectedRows.length === 0 || selectedRows.includes("-1");

    const sendToAi = (isBatch, userWantsBetterModel = false) => {
        if (loadingMode !== null) return;
        setLoadingMode(isBatch ? "batch" : "direct");

        const modeText = isBatch ? "Ουρά Batch" : "Απευθείας";
        setConsoleLines([`Εκκίνηση διαδικασίας (${modeText})... Παρακαλώ περιμένετε. Υπολογισμός κλήσεων...`]);

        const payloadRows = selectedRows.length === 0 ? ["-1"] : selectedRows;

        axios.post(`${process.env.REACT_APP_API_URL2}/ai/mass-send-cdrcalls-to-ai`, {
            selectedRows: payloadRows,
            filters: filters,
            company: company.id,
            isBatchMode: isBatch,
            userWantsBetterModel,
        }).then((res) => {
            if (res.data.status === "200") {
                if (typeof successfulCallback === "function") successfulCallback(payloadRows, isBatch);
                toast.success("Η διαδικασία αποστολής στο AI ολοκληρώθηκε.");
                setConsoleLines((prev) => [
                    ...prev,
                    ...(res.data.consoleLines || ["Η αποστολή ολοκληρώθηκε επιτυχώς."])
                ]);
                setTimeout(() => {
                    setLoadingMode(null);
                    setShow(false);
                }, 3500);
            } else {
                setLoadingMode(null);
                toast.error(res.data.message);
                setConsoleLines((prev) => [
                    ...prev,
                    ...(res.data.consoleLines || ["Παρουσιάστηκε σφάλμα."])
                ]);
            }
        }).catch((err) => {
            setLoadingMode(null);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            setConsoleLines((prev) => [...prev, "Σφάλμα κατά την επικοινωνία με τον server."]);
        });
    }

    const handleHide = () => {
        if (loadingMode !== null) {
            toast.info("Παρακαλώ περιμένετε μέχρι να τελειώσει η εργασία.");
        } else {
            setShow(false);
        }
    }

    const isLoading = loadingMode !== null;

    return (
        <Modal show={show} onHide={() => handleHide()} backdrop={"static"} dialogClassName={"modal50PercentWidth"}>
            <Modal.Header closeButton={!isLoading}>
                <Modal.Title>Μαζική αποστολή τηλεφωνικών κλήσεων στο Primer AI</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                ΠΡΟΣΟΧΗ! Θα γίνει μαζική αποστολή των <b>{isAllSelected ? "φιλτραρισμένων" : "επιλεγμένων"}</b> κλήσεων προς το Primer AI για απομαγνητοφώνηση και ανάλυση.<br /><br />
                <ul style={{fontSize: "14px", marginBottom: "10px"}}>
                    <li>Θα αποσταλούν <b>ΜΟΝΟ</b> οι κλήσεις που έχουν διάρκεια (Χρόνος Ομιλίας) μεγαλύτερη των 10 δευτερολέπτων.</li>
                    <li>Θα αγνοηθούν αυτόματα οι κλήσεις που δεν έχουν αρχείο ηχογράφησης.</li>
                    <li>Θα παραλειφθούν όσες κλήσεις έχουν ήδη αναλυθεί επιτυχώς στο παρελθόν.</li>
                </ul>
                Επιλέξτε μέθοδο αποστολής:

                {consoleLines.length > 0 && (
                    <React.Fragment>
                        <h5 style={{textAlign: "center"}} className={"mt-4"}>Κονσόλα Διαδικασίας:</h5>
                        <div style={{
                            height: "250px",
                            overflowY: "auto",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "10px",
                            backgroundColor: "#f8f9fa",
                            fontSize: "13px",
                            fontFamily: "monospace"
                        }} className={"mb-3"}>
                            {consoleLines.map((line, index) => (
                                <div key={index} style={{
                                    color: line.toLowerCase().includes("σφάλμα") || line.toLowerCase().includes("απέτυχε") ? "#dc3545" :
                                        line.toLowerCase().includes("επιτυχία") ? "#198754" :
                                            line.toLowerCase().includes("παράληψη") ? "#fd7e14" : "#212529",
                                    marginBottom: "4px"
                                }}>
                                    {line}
                                </div>
                            ))}
                        </div>
                    </React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => sendToAi(false, true)} disabled={isLoading}>
                    Απευθείας Αποστολή σε Gemini 3.8 (Ακριβότερο) {loadingMode === "direct" && <Spinner className={"ml-2"} animation={"border"} size="sm" variant={"light"} />}
                </Button>
                <Button variant="primary" onClick={() => sendToAi(false)} disabled={isLoading}>
                    Απευθείας Αποστολή {loadingMode === "direct" && <Spinner className={"ml-2"} animation={"border"} size="sm" variant={"light"} />}
                </Button>
                <Button variant="primary" onClick={() => sendToAi(true)} disabled={isLoading}>
                    Προσθήκη σε Ουρά (Batch) {loadingMode === "batch" && <Spinner className={"ml-2"} animation={"border"} size="sm" variant={"light"} />}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MassSendCdrAiModal;